const urlRegex = /(https?:\/\/.+)/i

export default function validateUrlFormat(url: string): boolean {
  //The backend will validate the complete url
  return urlRegex.test(url)
}
